/**
 * 编辑页附件上传组件
 */

angular
    .module('editPageModule')
    .directive('appendixUploadForEditPage', [function(){
        return {
            scope: false, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editPagePart/editPageAppendixUpload/editPageAppendixUpload.html',
            replace: true,
            link: function(scope, element, att) {
                initStatus();
                initData();

                /**
                 * [initStatus 初始化状态]
                 *
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    scope.appendixUpload = {
                        options: {
                            maxSize: 50,
                            isShowLabel: true,
                            labelName: '相关附件',
                            isShowAddIcon: true,
                            addButtonName: '添加',
                            uploadUrl: '/wcm/openapi/uploadFile',
                            listStyle: 'table',
                            showDesc: true
                        },
                        fileList: [],
                    };
                }

                /**
                 * [initData 初始化数据]
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    if (scope.list && scope.list.ATTACHFILE && scope.list.ATTACHFILE.length) {
                        let fileList = [];
                        angular.forEach(scope.list.ATTACHFILE, function (item){
                            fileList.push({
                                FILEINFO: '上传成功',
                                FileDesc: item.SRCFILE,
                                FileIntro: item.APPDESC,
                                FileName: item.APPFILE,
                                src: item.SRCPICURL || ''
                            });
                        });
                        scope.appendixUpload.fileList = fileList;
                    }
                }

                /**
                 * [fileUploadSuccess 附件上传成功的回调]
                 *
                 * @param   {[type]}  resp  [resp description]
                 * @param   {[type]}  file  [resp description]
                 *
                 * @return  {[type]}        [return description]
                 */
                scope.fileUploadSuccess = function(resp, file) {
                    if (resp.data.error) {
                        file.FILEINFO = '上传失败';
                    } else {
                        delete file.file;
                        file.FILEINFO = '上传成功';
                        file.FileDesc = file.FileName;
                        file.FileIntro = file.FileName;
                        file.FileName = resp.data.imgName;
                        file.FileSize = resp.data.fileSizeOfKB;
                        file.src = resp.data.imgSrc;
                    }
                };

                /**
                 * [fileUploadFail 文件上传失败处理]
                 *
                 * @param   {[type]}  resp  [resp description]
                 * @param   {[type]}  file  [file description]
                 *
                 * @return  {[type]}        [return description]
                 */
                scope.fileUploadFail = function(resp, file) {
                    if (resp.status === '413') {
                        file.FILEINFO = '文件太大，不得大于' + scope.appendixUpload.options.max + 'MB!';
                    } else {
                        file.FILEINFO = '未知错误!';
                    }
                };

                /**
                 * [fileUploadProgress 文件上传中]
                 *
                 * @param   {[type]}  evt   [evt description]
                 * @param   {[type]}  file  [file description]
                 *
                 * @return  {[type]}        [return description]
                 */
                scope.fileUploadProgress = function(evt, file) {
                    file.FILEINFO = '正在上传';
                    file.progress = parseInt(evt.loaded / evt.total * 100) + '%';
                };

                /**
                 * [getAppendixList 获取附件信息中的附件列表]
                 * @return  {[type]}  [return description]
                 */
                scope.getAppendixList = function () {
                    var fileList = [];
                    angular.forEach(scope.appendixUpload.fileList, function (item){
                        fileList.push({
                            APPFILE: item.FileName,
                            APPDESC: item.FileIntro,
                            SRCFILE: item.FileDesc
                        });
                    });
                    return fileList;
                };
            }
        };
    }]);
